<tr [formGroup]="taskForm" (ngSubmit)="save()">
    <td class="flex-4" appTitleProvider>
        <span>{{ unassignedTask.serviceName }}</span>
    </td>
    @if (rosterPresent) {
        <td class="flex-2" appTitleProvider>
            <span>{{ unassignedTask.rosterDepartmentName }}</span>
        </td>
    }
    <td class="flex-4">
        <app-dropdown
            formControlName="skillRequirement"
            [items]="skillLevelDropdownItems$ | async"
        ></app-dropdown>
    </td>
    <td class="flex-3" appTitleProvider>
        <span>{{ unassignedTask.fromTime + ' - ' + unassignedTask.toTime }}</span>
    </td>
    <td class="flex-2" appTitleProvider>
        <span>{{ unassignedTask.duration }} min</span>
    </td>
    <td class="flex-1 drag-preview-hide-col">
        <span>{{ unassignedTask.numberOfEmployees > 0 ? unassignedTask.numberOfEmployees : '1' }}</span>
    </td>
    <td class="flex-1 justify-content-center">
        <ng-container>
            <app-tooltip title="{{'REVERT' | translate}}" [compact]="true">
                <ng-container icon>
                    <button
                        type="reset"
                        class="vismaicon vismaicon-sm vismaicon-refresh vismaicon-reverse vismaicon-button"
                        (click)="revert()"
                    ></button>
                </ng-container>
            </app-tooltip>
            <app-tooltip title="{{'SAVE' | translate}}" [compact]="true">
                <ng-container icon>
                    <button
                        type="submit"
                        class="vismaicon vismaicon-sm vismaicon-save vismaicon-button"
                        [ngClass]="{ disabled: taskForm.pristine || taskForm.invalid }"
                        (click)="save()"
                    ></button>
                </ng-container>
            </app-tooltip>
        </ng-container>
    </td>
    <td class="flex-1 justify-content-end"></td>
    <td class="icon-column drag-preview-hide-col"></td>
    <td class="icon-column"></td>
</tr>
